export const instaCoffee = [{
    "id": "1",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-1.jpg",
    "brand": "COFEE ROSTER",
    "price": "699.99",
},
{
    "id": "2",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-2.jpg",
    "brand": "ONYXs",
    "price": "599.00", 
},
{
    "id": "3",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-3.jpg",
    "brand": "DOCKER ",
    "price": "499.50",
},
{
    "id": "4",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-4.jpg",
    "brand": "JAMES",
    "price": "649.99",
},
{
    "id": "5",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-5.jpg",
    "brand": "HAPPY COFFEE",
    "price": "699.00",
},
{
    "id": "6",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-6.jpg",
    "brand": "BOX COFFEE",
    "price": "599.50",
},
{
    "id": "7",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-7.jpg",
    "brand": "STARBUCKS",
    "price": "299.99",
},
{
    "id": "8",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-8.jpg",
    "brand": "GUTE LAUNE",
    "price": "689.00",
},
{
    "id": "9",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-9.jpg",
    "brand": "CAUSE ROAST",
    "price": "899.99",
},
{
    "id": "10",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-10.jpg",
    "brand": "CORTADO",
    "price": "599.00",
},
{
    "id": "11",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-11.jpg",
    "brand": "M CAFFEINE",
    "price": "349.50",
},
{
    "id": "12",
    "product": "CoffeeBeans",
    "image": "images/instaCoffee/img-12.jpg",
    "brand": "YOSEMITE",
    "price": "259.00",
}
]